import { useContext, useEffect, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import ApiContext from "src/provider/API/call-service";
import UserContext from 'src/provider/state-manager/userProvider';
import { Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenTitle } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import { TxPinVerification } from "src/component"
import { moneyFormat } from "src/utils/utility";
import helpers from "src/utils/helpers";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { differenceInMonths } from "date-fns";


export const StatementByEmail: React.FC<any> = ({close}) => {
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {user: {accountInfo, accountWithBalanceDetails, userInfo}} = useContext(UserContext)
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({accountNumber: '', startDate: '', endDate: '', shouldSendMail: true})
    const [view, setView] = useState('send-statement')

    useEffect(() => {
        if (accountWithBalanceDetails?.length === 1) {
            setInput({...input, accountNumber: accountWithBalanceDetails[0].nuban})
        }
    }, [accountWithBalanceDetails])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleProceed(
        e: React.FormEvent<HTMLButtonElement | HTMLFormElement>
    ) {
        e.preventDefault();

        if (differenceInMonths(input.endDate, input.startDate) > 3) {
            const response = await API.getTransactions(input);
            if (response)
                notifier.show("Statement Successfully Sent", null, "success");
            close();
        } else {
            await API.downloadAccountStatement({
                ...input,
                profileID: userInfo?.profileID,
            });
        }

    }

    // async function handleSubmit() {
    //     notifier.show('Statement Sent', null, 'success')
    //     close()
    // }

    return (
        <>
            { view === 'send-statement' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Generate Account Statement</ScreenTitle>
                    <CustomContainer topMargin='2.5'>
                        <Form onSubmit={handleProceed}>
                            <FormGroupWithIcon>
                                <label>Select Account</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='accountNumber'
                                        value={input.accountNumber}
                                        style={{color: input.accountNumber ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        disabled={accountWithBalanceDetails?.length === 1}
                                        required
                                    >
                                        <option value="">Select Account</option>
                                        {
                                            accountWithBalanceDetails?.map((item: any, index: number) => {
                                                return (
                                                    <option 
                                                        value={item.nuban || item.number} 
                                                        key={index}
                                                    >
                                                        {item.nuban || item.number} - ({moneyFormat(item?.balance?.withdrawableAmount,institutionData?.defaultCurrency)})
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroup>
                                <label>Start Date</label>
                                <input 
                                    placeholder='dd/mm/yyyy' 
                                    type='date'
                                    name='startDate'
                                    max={helpers.getInputValidDate()}
                                    style={{color: input.startDate ? '#000000' : '#667085'}}
                                    value={input.startDate}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>End Date</label>
                                <input 
                                    placeholder='dd/mm/yyyy' 
                                    type='date'
                                    name='endDate'
                                    max={helpers.getInputValidDate()}
                                    style={{color: input.endDate ? '#000000' : '#667085'}}
                                    value={input.endDate}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            {input?.startDate && input?.endDate && (
                                <FlexRow topMargin="2.5">
                                    <Button
                                        width="100"
                                        sizeUnit="%"
                                        height="4.4"
                                        borderColor="#0D968F"
                                        hoverBgColor="#fff"
                                        hoverColor="#0D968F"
                                        titleSize="1.4"
                                    >
                                        {differenceInMonths(input?.endDate, input?.startDate) > 3
                                            ? "Send Statement"
                                            : "Download Statement"}
                                    </Button>
                                </FlexRow>
                            )}
                        </Form>
                    </CustomContainer>
                </SidePopupLayout>
            }
            {/* { view === 'pin' &&
                <TxPinVerification
                    close={close}
                    next={handleSubmit} 
                />
            } */}
        </>
    )
}